export class Agent {
  id?: number;
  code?: string;
  region?: number;
  name?: string;
}
